//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Questions from '~/components/detail/desktop/questions'
// import DetailMoreInfosection from '~/components/detail/mobile/detail_more_infosection'
export default {
  name: 'DetailWeblog',
  components: {
    Questions
    // DetailMoreInfosection
  },
  props: {
    coin: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showFull: false
    }
  }
}
